module.exports = __webpack_public_path__ + "files/SPIADI2025 - Rapport national surveillance - octobre 2026.6d911fde782bc6f655e204bf0621d3dd.pdf";